import { t } from "@travily/i18n";
import { Icon } from "@ui/components/Icon";

export interface CoverMapBubbleProps {
  /** City name for the speech-bubble copy. */
  city: string;
}

/**
 * Centred overlay for a current-location map cover: a white speech-bubble pill
 * ("Hey! We're in {city}!") above the filled location marker. The cover map bakes
 * no pin, so the marker lives here in the DOM.
 */
export function CoverMapBubble({ city }: CoverMapBubbleProps) {
  return (
    <div className="pointer-events-none absolute inset-0 flex flex-col items-center justify-center gap-2">
      <div className="rounded-2xl bg-white px-4 py-2 text-center text-sm font-semibold text-neutral-900 shadow-md md:text-base">
        {t("components.views.shared.cover_frame.we_are_in", { city })}
      </div>
      <Icon className="size-14 drop-shadow" name="location" type="sticker" />
    </div>
  );
}
